import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { environment } from '../environments/environment';
import { IJobApply, JobApply } from '../models/jobAplly.model';

@Injectable({
  providedIn: 'root'
})

export class JobApplyService{

  constructor(private http: HttpClient){}

  getJobApply() : Observable<JobApply>{
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get<JobApply>(`${environment.url}/job_apply`,{'headers': headers});
  }

  query(page: number, size: number): Observable<any>{
    return this.http.get(`${environment.url}/job_apply?page=${page}&size=${size}`);
  }

//   saveJobApply(postId: number, file){
//     let headers = new HttpHeaders();
//     headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
//     return this.http.post<any>(`${environment.url}/job_apply/`+postId+,{'headers': headers});
//   }

  saveJobApply(postId: number, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post<any>(`${environment.url}/job_apply/${postId}`, formData, { 'headers': headers });
  }

  saveJobApply_new(postId: number, file: File, emailSeller: any): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('emailSeller', emailSeller);

    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));

    return this.http.post<any>(`${environment.url}/job_apply/${postId}`, formData, { 'headers': headers });
}


  getJobApplyById(idL:number)
  {
    return this.http.get(`${environment.url}/job_apply`+idL);
  }


  getIPostById(idA:number){
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem("kapo_session_id"));
    return this.http.get(`${environment.url}/job_apply`+idA,{'headers': headers});
  }

  updateJobApply(jobApply:IJobApply)
  {
    return this.http.put<any>(`${environment.url}/job_apply`+jobApply.id,jobApply);
  }

  deleteJobApply(idL:number)
  {
    return this.http.delete(`${environment.url}/job_apply`+idL);
  }

  utilisateurAyantPostuler(jobApplyId: number, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders().set('kapo_session_id', localStorage.getItem('kapo_session_id') || '');
    return this.http.get<any>(`${environment.url}/job_apply/user-job-list/${jobApplyId}${size ? '?page=' + page + '&size=' + size : ''}`, { headers });
  }

  getJobAppliesByDate(jobApplyId: number, startDate: any, endDate: any, page: number, size: number): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('kapo_session_id', '' + localStorage.getItem('kapo_session_id'));
    return this.http.get(`${environment.url}/job_apply/jobs-applies/${jobApplyId}?startDate=${startDate}&endDate=${endDate}&page=${page}&size=${size}`, { headers: headers });
  }

}
